'use strict';

document.querySelectorAll('.js_element_option').forEach(option => {
  option.addEventListener('click', function() {
    // Remove selected class from all options
    document.querySelectorAll('.js_element_option').forEach(item => {
      item.classList.remove('selected');
    });

    this.classList.add('selected');
  });
});